import React from 'react';
import styles from './Quiz.module.css';
import { motion, AnimatePresence } from 'framer-motion';
import Question from '../Question/Question';
import VarItem from '../VarItem/VarItem';
import VarItemCorrect from '../VarItemCorrect/VarItemCorrect';

const Quiz = ({
  variants,
  title,
  questionImgUrl,
  currentState,
  questionFontSize,
  answerFontSize,
  varNumFontSize,
  marginTopQuiz,
}) => {
  const isLong = title?.length > 170;

  let count = 0;

  if (currentState === 'S1') return null;

  return (
    <div
      className={styles.containerQuize}
      style={{ marginTop: `${Number(marginTopQuiz)}rem` }}>
      <Question
        title={title}
        questionImgUrl={questionImgUrl}
        isLong={isLong}
        questionFontSize={questionFontSize}
      />

      <div
        className={questionImgUrl ? styles.blockQuiz : styles.blockQuizNoImg}
        key={questionImgUrl}>
        {questionImgUrl && (
          <motion.div
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
            }}
            transition={{ duration: 0.5, delay: 0.5 }}
            className={styles.blockImgQuestion}>
            <img src={questionImgUrl} alt="" className={styles.questionImg} />
          </motion.div>
        )}

        <div
          className={
            styles[questionImgUrl ? 'vars-wrapper' : 'vars-wrapper-noImg']
          }>
          <div className={styles[questionImgUrl ? 'vars' : 'vars-noImg']}>
            {variants?.map((item, i) => {
              if (item.comment.length > 36 && !item.correct) {
                // 36 символов в одной строке
                count++;
              }
              return (
                <motion.div
                  initial={{
                    transform: 'scale(0)',
                    opacity: 0,
                    originX: 0,
                    originY: 'center',
                  }}
                  animate={{
                    transform: 'scale(1)',
                    opacity: 1,
                    originX: 0,
                    originY: 'center',
                  }}
                  transition={{ duration: 1, delay: i * 0.8 + 2.5 }} // 2.5 анимация вопроса
                  key={item.comment}
                  style={{ display: 'flex', alignItems: 'center' }}>
                  <div className={styles.varRight}>
                    {questionImgUrl ? (
                      // <AnimatePresence>
                      <>
                        {currentState === 'S3' ||
                        currentState === 'S4' ||
                        !currentState ? (
                          item.correct ? (
                            <motion.div
                              animate={{
                                y: -(79 * i + i * 19.2 + count * 39), // 79 высота ответа в 1 строку, 19,2 - отступ между вариантами,79+39 высота ответа в 2 строки
                              }}
                              exit={{ opacity: 0 }}
                              transition={{
                                duration: 0.5,
                                delay: 2.8,
                              }}>
                              <VarItemCorrect
                                item={item}
                                i={i}
                                answerFontSize={answerFontSize}
                                varNumFontSize={varNumFontSize}
                                isQuestionImg
                              />
                            </motion.div>
                          ) : (
                            <motion.div
                              initial={{ opacity: 1 }}
                              animate={{ opacity: 0 }}
                              transition={{ duration: 0.6, delay: 2.2 }}>
                              <VarItem
                                item={item}
                                i={i}
                                answerFontSize={answerFontSize}
                                varNumFontSize={varNumFontSize}
                                isQuestionImg
                              />
                            </motion.div>
                          )
                        ) : (
                          <VarItem
                            item={item}
                            i={i}
                            answerFontSize={answerFontSize}
                            varNumFontSize={varNumFontSize}
                            isQuestionImg
                          />
                        )}
                      </>
                    ) : (
                      // </AnimatePresence>
                      <>
                        {currentState === 'S3' ||
                        currentState === 'S4' ||
                        !currentState ? (
                          item.correct ? (
                            <VarItemCorrect
                              item={item}
                              i={i}
                              answerFontSize={answerFontSize}
                              varNumFontSize={varNumFontSize}
                            />
                          ) : (
                            <VarItem
                              item={item}
                              i={i}
                              answerFontSize={answerFontSize}
                              varNumFontSize={varNumFontSize}
                            />
                          )
                        ) : (
                          <VarItem
                            item={item}
                            i={i}
                            answerFontSize={answerFontSize}
                            varNumFontSize={varNumFontSize}
                          />
                        )}
                      </>
                    )}
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Quiz);
